import { arrayRemove } from "../utils";
import IDocument from "../interface/document";
import DocumentsQuery from "../class/documents-query";
import DocumentsCacheItem from "../class/documents-cache-item";

class DocumentsCacheInstance {

    private Cache: DocumentsCacheItem[] = [];

    public add(entityId: number, data: IDocument[], query: DocumentsQuery | null = null): void {
        this.checkExpired();
        this.Cache.push(new DocumentsCacheItem(entityId, data, query));
    }

    public get(entityId: number, query: string = ''): IDocument[] | null {
        this.checkExpired();
        const item = this.Cache.find((item: DocumentsCacheItem) => {
            return item.entityId === entityId && item.query.toString() === query;
        });
        if (item) {
            return [...item.getData()];
        }
        return null;
    }

    public clear(entityId: number | undefined = undefined): void {
        if (entityId) {
            const items: DocumentsCacheItem[] = this.getByEntity(entityId)
            items.forEach((item: DocumentsCacheItem) => {
                item.clear()
                arrayRemove(this.Cache, item);
            });
        } else {
            this.Cache.forEach((item: DocumentsCacheItem) => item.clear());
            this.Cache = [];
        }
    }

    public documentsCreate(entityId: number, records: IDocument[]): void {
        this.getByEntity(entityId).forEach((item: DocumentsCacheItem) => item.documentsCreate(records));
    }

    public documentsUpdate(entityId: number, records: IDocument[]): void {
        this.getByEntity(entityId).forEach((item: DocumentsCacheItem) => item.documentsUpdate(records));
    }

    public documentsDelete(entityId: number, records: IDocument[]): void {
        this.getByEntity(entityId).forEach((item: DocumentsCacheItem) => item.documentsDelete(records));
    }

    public dictionaryUpdate(entityId: number): void {
        this.clearItems(this.getByEntity(entityId));
    }

    private checkExpired(): void {
        this.clearItems(this.Cache.filter(item => item.expired()));
    }

    private clearItems(items: DocumentsCacheItem[]): void {
        items.forEach(item => arrayRemove(this.Cache, item));
    }

    private getByEntity(entityId: number): DocumentsCacheItem[] {
        return this.Cache.filter(item => item.entityId === entityId);
    }

}

const DocumentsCache = new DocumentsCacheInstance();

export default DocumentsCache;